import { Trash2Icon } from "@lucide/icons";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";
import { Input } from "simplydo/react/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "simplydo/react/ui/table";

import { FieldProps, TableFieldValue } from "./FieldProps";

const TableField = ({
  field,
  fieldValue,
  updateIdea,
  isEditing,
}: FieldProps) => {
  const tableValue = (fieldValue as TableFieldValue) || {};
  const currentData = tableValue.data || [{}];
  const columns = field.columns || [];

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {columns.map((col) => (
            <TableHeaderCell key={col.id}>
              {col.title}
              {col.required ? (
                <span style={{ color: "#cd0e2b" }}>{"\u00A0*"} </span>
              ) : null}
            </TableHeaderCell>
          ))}
          {isEditing ? <TableHeaderCell /> : null}
        </TableRow>
      </TableHeader>
      <TableBody>
        {currentData.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((col) => {
              const cell = row[col.id] || { value: "" };

              return (
                <TableCell key={col.id}>
                  {isEditing ? (
                    <Input
                      fluid
                      defaultValue={cell.value}
                      onChange={(_e, data) => {
                        const newData = [...currentData];
                        const row = newData[rowIndex] ?? {};
                        newData[rowIndex] = row;
                        row[col.id] = { value: data.value };
                        updateIdea({ ...(tableValue || {}), data: newData }, [
                          "templated",
                          field.id,
                        ]);
                      }}
                    />
                  ) : (
                    cell.value
                  )}
                </TableCell>
              );
            })}
            {isEditing ? (
              <TableCell collapsing>
                <Button
                  onClick={() => {
                    const newData = currentData.filter(
                      (_row, i) => i !== rowIndex,
                    );
                    updateIdea({ ...(tableValue || {}), data: newData }, [
                      "templated",
                      field.id,
                    ]);
                  }}
                  variant="outline"
                >
                  <Icon icon={Trash2Icon} />
                </Button>
              </TableCell>
            ) : null}
          </TableRow>
        ))}
        {isEditing ? (
          <TableRow>
            <TableCell colSpan={(columns.length || 1) + (isEditing ? 1 : 0)}>
              <Button
                onClick={() => {
                  const newData = [...currentData, {}];
                  updateIdea({ ...(tableValue || {}), data: newData }, [
                    "templated",
                    field.id,
                  ]);
                }}
                color="primary"
              >
                Add Row
              </Button>
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
    </Table>
  );
};

export default TableField;
